const Settings = {
	GOOGLE_MAPS_API_KEY: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
	API_URL: process.env.VUE_APP_API_URL,
	markets: {
		google: 'https://play.google.com/store/apps/details?id=com.dynamix.teamprinter',
		apple:  'https://apps.apple.com/app/id1380754569'
	}
};

export default Settings;